<script setup>
import { Link, usePage } from '@inertiajs/vue3'
import { EnvelopeOpenIcon, DevicePhoneMobileIcon } from '@heroicons/vue/24/outline'
import { index as contactIndex } from '@/actions/App/Http/Controllers/ContactController'

const page = usePage()
</script>

<template>
    <section class="bg-brand-primary/5 border-brand-primary/20 rounded-3xl border p-8 sm:p-12 ">
        <div class="mx-auto max-w-3xl text-center">
            <h3 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                Máte dotaz nebo potřebujete poradit?
            </h3>
            <p class="mx-auto mt-4 max-w-xl text-gray-600">
                Neváhejte nás kontaktovat. Rádi vám pomůžeme s výběrem správného řešení pro váš projekt.
            </p>

            <!-- Contact info - inline -->
            <div class="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm">
                <a
                    :href="'mailto:' + page.props.contacts?.email"
                    class="hover:text-brand-primary inline-flex items-center gap-2 text-gray-700 transition-colors"
                >
                    <EnvelopeOpenIcon class="text-brand-primary size-5" />
                    {{ page.props.contacts?.email ?? 'info@kalianko.cz' }}
                </a>
            </div>

            <!-- Buttons -->
            <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
                <Link
                    :href="contactIndex().url + '#demand-form'"
                    class="primary-link rounded-full text-base"
                >
                    Objednávkový formulář
                </Link>
                <a
                    :href="'tel:' + page.props.contacts?.phone?.replace(/\s/g, '')"
                    class="border-brand-primary/30 bg-brand-primary/10 text-brand-primary hover:bg-brand-primary/20 inline-flex items-center rounded-full border px-6 py-3 text-base font-semibold transition"
                >
                    <DevicePhoneMobileIcon class="mr-2 size-5" />
                    Zavolejte nám
                </a>
            </div>
        </div>
    </section>
</template>
